import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          subscription: Yup.string()
                                                           .required('Required'),
                                          price: Yup.string()
                                                    .required('Required'),
                                      });
